
(function () {
  const PHONE_TEXT = "+55 11 5108-4955";
  const PHONE_HREF = "tel:+551151084955";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function findHeader() {
    return (
      document.querySelector("header") ||
      document.querySelector(".shopify-section-header") ||
      document.querySelector("[id*='shopify-section-header']") ||
      document.querySelector(".site-header")
    );
  }

  function findHeaderRow(header) {
    return (
      header.querySelector(".header") ||
      header.querySelector(".header__wrapper") ||
      header.querySelector(".header__inner") ||
      header.querySelector(".site-header__inner") ||
      header.querySelector("nav")?.parentElement ||
      header
    );
  }

  function hideLegacyHeaderTools(header) {
    const selectors = [
      "form[action='/search']",
      "form[action*='/search']",
      "predictive-search",
      ".search-modal",
      ".header__search",
      ".site-header__search",
      ".search__button",
      "button[aria-label*='Search']",
      "button[aria-label*='Pesquisar']",
      "a[href='/search']",
      "a[href^='tel:']",
      "a[href*='800-460']",
      "a[href*='6276']",
      "a[href*='98234']"
    ];

    selectors.forEach(selector => {
      header.querySelectorAll(selector).forEach(el => {
        if (el.closest(".evora-header-tools")) return;
        el.setAttribute("data-evora-hidden-header-tool", "true");
        el.style.setProperty("display", "none", "important");
      });
    });
  }

  function createPhone() {
    const phone = document.createElement("a");
    phone.className = "evora-header-phone";
    phone.href = PHONE_HREF;
    phone.setAttribute("aria-label", "Ligar para Évora Global");
    phone.innerHTML = `
      <svg class="evora-header-phone-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.8 19.8 0 0 1 11.19 18a19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 1.28 3.37 2 2 0 0 1 3.27 1.2h3a2 2 0 0 1 2 1.72c.12.91.33 1.8.63 2.65a2 2 0 0 1-.45 2.11L7.18 8.95a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.85.3 1.74.51 2.65.63A2 2 0 0 1 22 16.92Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>${PHONE_TEXT}</span>
    `;
    return phone;
  }

  function createSearch() {
    const wrap = document.createElement("div");
    wrap.className = "evora-header-search";
    wrap.innerHTML = `
      <button class="evora-header-search-toggle" type="button" aria-label="Pesquisar" aria-expanded="false">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2.4"></circle>
          <path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"></path>
        </svg>
      </button>

      <div class="evora-header-search-popover" role="dialog" aria-label="Busca">
        <form class="evora-header-search-form" action="/search" method="get" role="search">
          <input class="evora-header-search-input" type="search" name="q" placeholder="Pesquise produtos, marcas..." autocomplete="off">
        </form>
      </div>
    `;

    const button = wrap.querySelector(".evora-header-search-toggle");
    const popover = wrap.querySelector(".evora-header-search-popover");
    const input = wrap.querySelector(".evora-header-search-input");

    button.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      const isOpen = popover.classList.toggle("is-open");
      button.setAttribute("aria-expanded", isOpen ? "true" : "false");

      if (isOpen) {
        setTimeout(() => input.focus(), 40);
      }
    });

    document.addEventListener("click", function (event) {
      if (!wrap.contains(event.target)) {
        popover.classList.remove("is-open");
        button.setAttribute("aria-expanded", "false");
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        popover.classList.remove("is-open");
        button.setAttribute("aria-expanded", "false");
      }
    });

    return wrap;
  }

  function findCartElement(header) {
    return (
      header.querySelector("a[href='/cart']") ||
      header.querySelector("a[href*='/cart']") ||
      header.querySelector("cart-icon-bubble") ||
      header.querySelector(".header__icon--cart") ||
      header.querySelector(".cart-link")
    );
  }

  function install() {
    const header = findHeader();
    if (!header) return;

    if (header.querySelector(".evora-header-tools")) {
      hideLegacyHeaderTools(header);
      return;
    }

    hideLegacyHeaderTools(header);

    const row = findHeaderRow(header);
    const tools = document.createElement("div");
    tools.className = "evora-header-tools";
    tools.appendChild(createPhone());
    tools.appendChild(createSearch());

    const cart = findCartElement(header);

    if (cart && cart.parentElement) {
      cart.parentElement.insertBefore(tools, cart);
    } else {
      row.appendChild(tools);
    }
  }

  ready(function () {
    install();

    setTimeout(install, 300);
    setTimeout(install, 1000);
  });
})();
